var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7996 10.5C15.7996 11.2956 15.4811 12.0587 14.9141 12.6213C14.3471 13.1839 13.5781 13.5 12.7763 13.5C11.9744 13.5 11.2054 13.1839 10.6384 12.6213C10.0715 12.0587 9.75293 11.2956 9.75293 10.5C9.75293 9.70435 10.0715 8.94129 10.6384 8.37868C11.2054 7.81607 11.9744 7.5 12.7763 7.5C13.5781 7.5 14.3471 7.81607 14.9141 8.37868C15.4811 8.94129 15.7996 9.70435 15.7996 10.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.3345 10.5C20.3345 17.642 12.7761 21.75 12.7761 21.75C12.7761 21.75 5.21777 17.642 5.21777 10.5C5.21777 8.51088 6.0141 6.60322 7.43156 5.1967C8.84903 3.79018 10.7715 3 12.7761 3C14.7807 3 16.7032 3.79018 18.1207 5.1967C19.5381 6.60322 20.3345 8.51088 20.3345 10.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7154970730b50501fc0c34d6945369b6.svg";
export { ForwardRef as ReactComponent };